import CallApp from 'callapp-lib'
import { appUser } from '@/utils'
import { send } from '@/utils/common/native-api'

var ua = navigator.userAgent.toLowerCase()
let isWeixin = ua.match(/micromessenger/i) == 'micromessenger'
let isIos = /ipad|iPhone|Mac/i.test(ua)

let getPath = (name, option) => {
  if (!name) name = 'app'
  let optionStr = ''
  if (option.option) optionStr = getOptionStr(option.option, option.optionArr)
  return name + optionStr
}
let getOptionStr = (option, optionArr) => {
  if (optionArr && optionArr.length > 0) {
    let str = '?'
    optionArr.forEach((item, index) => {
      str += (index !== 0 ? '&' : '') + item + '=' + option[item]
    })
    return str
  }
  return (
    '?' +
    Object.entries(option)
      .map(([key, value]) => `${key}=${value}`)
      .join('&')
  )
}

let openApp = path => {
  const options = {
    scheme: {
      protocol: 'youthapp'
    },
    intent: {
      scheme: 'youthapp',
      package: 'com.ylyk.youth'
    },
    universal: {
      host: 'youth.ylyk.com',
      pathKey: ''
    },
    appstore: 'https://apps.apple.com/app/%E5%8F%8B%E9%82%BB%E5%B0%91%E5%B9%B4/id6670519177', //填写appstore的下载地址
    yingyongbao: 'https://sj.qg.com/appdetail/com.ylyk.youth', //填写应用宝的下载地址
    fallback: 'https://download.ylyk.com/ylsn.html' //填写唤端失败后跳转的地址。
  }
  const callLib = new CallApp(options)
  console.log(path, 'path')
  callLib.open({
    path
  })
}

export let skipApp = function (option, that) {
  let typeOption = getOption(option.type, option)
  // app内
  if (appUser.isNative) {
    send(typeOption.inner, option)
  } else {
    if (isWeixin) {
      window.location.href =
        `share.html?shareCode=${that.shareCode}#/` + typeOption.h5path + getOptionStr(option, typeOption.optionArr)
    } else {
      openApp(getPath(null, { option, ...typeOption }))
    }
  }
}

let getOption = (type, options) => {
  let option = {}
  switch (type) {
    case 'album':
    case '20001': //专辑
      option = {
        inner: 'gotoAlbumPage',
        h5path: 'share-course',
        optionArr: ['type', 'albumGoodsId']
      }
      break
    case '60001': // 卡券
      option = {
        inner: 'gotoCouponPage',
        type: 'coupon',
        h5path: 'share-default',
        optionArr: ['type']
      }
      break
    case 'credit': //积分商城
      option = {
        inner: 'gotoMallPage',
        type: 'mall',
        h5path: 'share-default',
        optionArr: ['type']
      }
      break
    case 'live':
      option = {
        inner: '',
        type: 'live',
        h5path: 'share-live',
        optionArr: ['type', 'roomId']
      }
      break
    default:
      option = {
        inner: options.inner,
        type,
        h5path: options.h5path,
        optionArr: options.optionArr
      }
  }
  return option
}
